export default "__VITE_ASSET__CXDs5j2y__"